// Maximum amount of time we want to wait for the Glider library to be available on the window object
const waitForGliderLibTimeout = 10000;

/**
 * Wait until the Glider is available on the window object
 * @returns {Promise<unknown>}
 */
export function waitUntilGliderIsLoaded() {
    const start = Date.now();

    return new Promise(waitForGlider);

    function waitForGlider(resolve, reject) {
        if (window.Glider) {
            resolve(window.Glider);
        } else if (waitForGliderLibTimeout && (Date.now() - start) >= waitForGliderLibTimeout) {
            reject(new Error('Could not initialize the slider'))
        } else {
            setTimeout(waitForGlider.bind(this, resolve, reject), 50);
        }
    }
}
